module.exports = __webpack_public_path__ + "media/images/flags/64/Guam-2677e83cdcfb007324a36d924ed69789.png";